module.exports = __webpack_public_path__ + "img/Header-Background-top_.d9fe1d53.png";